// This icon file is generated automatically.
var DropletFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.95 3l5.27 5.27a7.46 7.46 0 11-10.54 0L11.95 3z" } }] }, "name": "droplet", "theme": "filled" };
export default DropletFilled;
